import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';

export default function useUserData() {
	return useSelector(selectUser).data;
}
